export const environment = {
  production: true,
  apiRootUrl: 'https://CLWIP-API.ohl.com/',
  loginUrl: 'https://websynapse2-api.ohl.com/',
  hubConnectionUrl: 'https://CLWIP-API.ohl.com/',
  hubName: 'notificationHub',
  //AccessGroupKey in 'Work In Progress Management System'
  accessGroupKey: 'WIMS',
  accessName: ['WIMSADM','WIMSUSR'],
  CookieExpirationTime: '1',
  defaultSearchDateRange: 6,
  excelReport : 'https://CLWIP-API.ohl.com/FileDownload/ExcelReport?exportFilter=',
  IsGAEnabled: true,
  GAAccount: 'G-GGKDYMG7BQ'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts